import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'
import { cn } from '@/lib/utils'
import { useTranslation } from 'react-i18next'

type BronzeMatchToggleProps = {
  id?: string
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  label?: string
  description?: string
  disabled?: boolean
  className?: string
}

export function BronzeMatchToggle({
  id = 'bronze-match-toggle',
  checked,
  onCheckedChange,
  label,
  description,
  disabled,
  className,
}: BronzeMatchToggleProps) {
  const { t } = useTranslation()
  const resolvedLabel =
    label ?? t('groupStage.setup.includeBronze', 'Include bronze medal match')

  return (
    <div className={cn('flex items-center justify-between gap-3', className)}>
      <div className="flex-1">
        <Label htmlFor={id} className="text-sm font-medium leading-5">
          {resolvedLabel}
        </Label>
        {description && (
          <p className="mt-1 text-xs text-muted-foreground">{description}</p>
        )}
      </div>
      <Switch
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
      />
    </div>
  )
}
